import { React } from "react";
import { useState, useEffect } from "react";
import { Film } from "lucide-react";
import Footer from "./Footer";

import OfficialRules from "../../config/kolandium-rules";

// Helper to get IST date
function getISTDate() {
  const now = new Date();
  // IST is UTC+5:30
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  return new Date(utc + 5.5 * 60 * 60 * 1000);
}

const LAUNCH_DATE_IST = new Date("2025-08-15T00:00:00+05:30");
const SESSION_END_DATE_IST = new Date("2026-05-31T00:00:00+05:30");

function calculateTimeLeft(targetDate) {
  const difference = +targetDate - +getISTDate();
  let timeLeft = {};
  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }
  return timeLeft;
}


export function Home() {
  // Determine which timer to show and what text
  const [showRules, setShowRules] = useState(false);
  const [timerState, setTimerState] = useState({
    showTimer: true,
    timerText: "",
    timeLeft: {},
  });

  useEffect(() => {
    function updateTimer() {
      const now = getISTDate();
      if (now <= LAUNCH_DATE_IST) {
        setTimerState({
          showTimer: true,
          timerText: "Timer Left Until Launch:",
          timeLeft: calculateTimeLeft(LAUNCH_DATE_IST),
        });
      } else if (now > LAUNCH_DATE_IST && now < SESSION_END_DATE_IST) {
        setTimerState({
          showTimer: true,
          timerText: "Time remaining in the current session of TOP LIVE:",
          timeLeft: calculateTimeLeft(SESSION_END_DATE_IST),
        });
      } else {
        setTimerState({
          showTimer: false,
          timerText: "",
          timeLeft: {},
        });
      }
    }
    updateTimer();
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: "url('images/bg.jpg')",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="mx-auto max-w-2xl text-center bg-white bg-opacity-100  p-6 mt-8">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          Kolandium
        </h2>
        {/* Timer Section */}
        {timerState.showTimer && (
          <div className="mt-6 text-lg leading-8 text-gray-600 text-center">
            <p>{timerState.timerText}</p>
            <div className="flex justify-center space-x-4 mt-4">
              <div className="bg-gray-200 p-4 rounded-lg shadow-lg">
                <p className="text-2xl font-bold">{timerState.timeLeft.days}</p>
                <p className="text-sm">Days</p>
              </div>
              <div className="bg-gray-200 p-4 rounded-lg shadow-lg">
                <p className="text-2xl font-bold">{timerState.timeLeft.hours}</p>
                <p className="text-sm">Hours</p>
              </div>
              <div className="bg-gray-200 p-4 rounded-lg shadow-lg">
                <p className="text-2xl font-bold">{timerState.timeLeft.minutes}</p>
                <p className="text-sm">Minutes</p>
              </div>
              <div className="bg-gray-200 p-4 rounded-lg shadow-lg">
                <p className="text-2xl font-bold">{timerState.timeLeft.seconds}</p>
                <p className="text-sm">Seconds</p>
              </div>
            </div>
          </div>
        )}
        {/* ...existing code... */}
        <div className="text-center mb-8 bg-white">
          <div
            className="inline-flex items-center justify-center w-16 h-16 mb-4"
            style={{ background: "var(--primary-grey)", color: "white" }}
          >
            <Film className="w-8 h-8" />
          </div>
          <h1
            className="text-4xl font-bold mb-2"
            style={{ color: "var(--secondary-grey)" }}
          >
            OFFICIAL RULES
          </h1>
          <h2
            className="text-2xl font-semibold mb-4"
            style={{ color: "var(--primary-grey)" }}
          >
            Kolandium SHORT FILM COMPETITION
          </h2>
          <div
            className="w-24 h-1 mx-auto rounded-full"
            style={{ background: "var(--primary-grey)" }}
          ></div>
          <div className="flex justify-center mt-6">
            <button
              className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded shadow"
              onClick={() => setShowRules((prev) => !prev)}
            >
              {showRules ? "Hide Official Rules" : "Show Official Rules"}
            </button>
          </div>
        </div>
      </div>
      {/* Header */}

      {/* Official Rules Section */}
      {showRules && (
        <div className="mt-6 text-lg leading-8 text-gray-600 text-center bg-white bg-opacity-70 rounded-lg mx-auto max-w-2xl p-4">
          <OfficialRules />
        </div>
      )}

      <div>
        <div className="mt-40 bottom-1">
          <Footer companyName="Your Company" year={new Date().getFullYear()} />
        </div>
      </div>
    </div>
  );
}
